import React, { Component } from "react";
import "./Webinars.css";
import { WebinarsItem } from "./WebinarsItem";
import SimpleSlider from "../SimpleSlider/SimpleSlider";
import { getImgUrl, limitText } from "../../Utility/Utility";
import { WebinarsData } from "../../Data/Data";

class Webinars extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();

    this.WebinarsSliderSettings = {
      dots: false,
      infinite: true,
      cssEase: "linear",
      autoplay: false,
      lazyLoad: "ondemand",
      arrows: false,
      slidesToShow: this.props.items != undefined ? this.props.items : 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    };
  }

  render() {
    const data = [...WebinarsData];
    const postsHtml = data.map((o, i) => {
      console.log("o.category: ", o.category);
      console.log("this.props.category: ", this.props.category);

      if (this.props.category == o.category) {
        return (
          <WebinarsItem
            desc={o.desc}
            imgVideo={o.imgVideo}
            vidId={o.vidId}
            id={i}
            key={i}
          />
        );
      }
    });
    return (
      <div className="webinars-wrapper">
        {/*<SimpleSlider settings={this.WebinarsSliderSettings}>{postsHtml}</SimpleSlider>*/}

        {postsHtml}
      </div>
    );
  }
}

export default Webinars;



// WEBPACK FOOTER //
// ./src/Components/Webinars/Webinars.js